import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import type { PaginatedContextData, PaginatedData } from '#src/app/shared/contexts/asyncData';

import { LocalTrendingPetitions } from './api.graphql';
import type { LocalTrendingPetitionsQuery, LocalTrendingPetitionsQueryVariables } from './api.graphql';
import type { LocalTrendingPetitionsItem } from './types';

type LocalTrendingPetitionsApiData = PaginatedData<
	LocalTrendingPetitionsItem,
	{
		totalCount: number;
		totalCountLocalized: string;
	}
>;

/** @knip-ignore */
export type LocalTrendingPetitionsData = PaginatedContextData<LocalTrendingPetitionsApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	queryParams: {
		listTagsFilter: string | undefined;
	},
	cursor?: string,
): Promise<LocalTrendingPetitionsApiData> {
	const { data } = await fetch<LocalTrendingPetitionsQuery, LocalTrendingPetitionsQueryVariables>({
		query: LocalTrendingPetitions,
		variables: { slug, cursor: cursor ?? null, tagIds: queryParams.listTagsFilter?.split(',') || null },
		rejectOnError: true,
	});

	if (!data.localPageLocation) throw new NotFoundError();

	return {
		items: data.localPageLocation.trendingPetitionsConnection.edges,
		cursor: data.localPageLocation.trendingPetitionsConnection.pageInfo.endCursor,
		hasNextPage: data.localPageLocation.trendingPetitionsConnection.pageInfo.hasNextPage,
		totalCount: data.localPageLocation.trendingPetitionsConnection.totalCount,
		totalCountLocalized: data.localPageLocation.trendingPetitionsConnection.totalCountLocalized,
	};
}

export async function getFirstPageData(
	utilityContext: UtilityContext,
	slug: string,
	queryParams: { listTagsFilter: string | undefined },
) {
	return getData(utilityContext, slug, queryParams);
}

export async function getNextPageData(
	utilityContext: UtilityContext,
	cursor: string,
	slug: string,
	queryParams: { listTagsFilter: string | undefined },
) {
	return getData(utilityContext, slug, queryParams, cursor);
}
